import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import image1 from "../assets/images/image1.jpeg";

const Content = () => {
  return (
    <Container className="m-auto">
      <Row>
        <Col className="m-3" xs={5} style={{ justifyContent: "center" }}>
          <h2 style={{ marginTop: "22%", justifyContent: "center" }}>
            Welcome ! In React Basic Projects For Beginners and Improve the
            Technical Skills With Various Logic and Fundamentals of React Js{" "}
          </h2>
          <p>
            Hello! I am Isha Narola. I have put here the all basic demo Projects
            as well as small Form componments with Formik also It has Validation
            and Dynamic Rules with it. Here more than 8 Projects as a Beginners
            as like Notes app, Calculator, FireBase Vote Counting ,Quiz
            App,Student Management System ,Language Dettection,Dashboard with
            Live Covid API, Weather API also many More small Tasks with Real
            Time API as well as Real Time Form Scenario With Proper Regex and
            Keep Track of all Real time rules ....
          </p>
        </Col>
        <Col className="m-3" xs={5}>
          <img
            src={image1}
            alt={"content "}
            className="herosectionimage"
            style={{ width: "99%", marginTop: "25%" }}
          ></img>
        </Col>
      </Row>
    </Container>
  );
};

export default Content;
